<template>
  <div>
    <!-- Mobile carousel -->
    <carousel
      v-show="isMobile"
      ref="myCarousel"
      class="cursor"
      :minSwipeDistance="20"
      paginationActiveColor="#FE7900"
      paginationColor="#000000"
      :paginationEnabled="false"
      :autoplayHoverPause="false"
      :autoplay="true"
      :scrollPerPage="true"
      easing="linear"
      :loop="true"
      :speed="800"
      :autoplayTimeout="5000"
      :perPage="1"
      @transitionStart="onSlideChange"
       @pageChange="onAfterSlideChange"
    >
      <slide v-for="(val, key) in categories" :key="key">
        <router-link :to="{ name: 'election' }" v-if="key == 2">
          <div class="serviceBox" :class="val.color">
            <h3 class="title">{{ val.name }}</h3>
            <p class="description" v-html="val.description"></p>
            <div class="service-icon">
              <span><img :class="val.imgclass" :src="val.image" /></span>
            </div>
          </div>
        </router-link>
        <router-link :to="{ name: 'category', params: { category: val.name } }" v-else>
          <div class="serviceBox" :class="val.color">
            <h3 class="title">{{ val.name }}</h3>
            <p class="description" v-html="val.description"></p>
            <div class="service-icon">
              <span><img :class="val.imgclass" :src="val.image" /></span>
            </div>
          </div>
        </router-link>
       <template v-if="key != 2">
          <template v-if="data[key]">
         <div v-for="(val,key1) in data[key]" :key="key1" >
           <template v-if="val.length">
              <div class="headingqtn mt-4" > 
                <span v-if="key1 == 'latest'">Latest Question</span>
                <span v-else-if="key1 == 'most_popular'">Most Popular</span>
                <span v-else-if="key1 == 'ending_soon'">Ending Soon</span>
              </div>
               
              <div class="qustdiv mt-1">
            <div v-for="(vals,keys) in val" :key="keys">
           <div class="question-top" @click="gotoqst(vals.id)">
             <div class="qtpart">Q. {{ vals.question }}</div>
             <div class="qt-votes">{{ vals.total_votes }} votes</div>
           </div>
          </div> 
        </div>
          </template>
         </div> 
         </template>         
       </template>
       <template v-else>
        
          <template v-if="data[key] && data[key].length > 0">
            <Votefile :data="decryptMe(data[key])" v-if="data[key]" />
           </template>
       </template>  
      </slide>
     
    </carousel>
    <!-- Desktop grid -->
     
    <div class="row mainrow" v-show="!isMobile">
      <div
        class="col-md-3 col-sm-6 cursor"
        v-for="(val, key) in categories"
        :key="key"
      >
        <router-link :to="{ name: 'election' }" v-if="key == 2">
          <div class="serviceBox" :class="val.color">
            <h3 class="title">{{ val.name }}</h3>
            <p class="description" v-html="val.description"></p>
            <div class="service-icon">
              <span><img :class="val.imgclass" :src="val.image" /></span>
            </div>
          </div>
        </router-link>
        <router-link :to="{ name: 'category', params: { category: val.name } }" v-else>
          <div class="serviceBox" :class="val.color">
            <h3 class="title">{{ val.name }}</h3>
            <p class="description" v-html="val.description"></p>
            <div class="service-icon">
              <span><img :class="val.imgclass" :src="val.image" /></span>
            </div>
          </div>
        </router-link>
      </div>
    </div>
  </div>
</template>

<script>
import { getUserTimezone } from '../plugins/timezone';
import { Carousel, Slide } from "vue-carousel";
import CryptoJS from 'crypto-js';
import { encryptionKey } from '../../config';
import Votefile from "./Votefile.vue";

export default {
  name: "Homecategory",
  components: {
    Carousel,
    Slide,
    Votefile
  },
  data() {
    return {
      isMobile: false,
      showQuestion:true,
      categories: {
        0: {
          name: "Sports",
          color: "bluecolor",
          image: require("@/assets/sports.png"),
          imgclass: "sportsicon",
          description: "Vote on every sport from <br/> around the World",
        },
        1: {
          name: "Anything",
          color: "orangecolor",
          image: require("@/assets/anything.png"),
          imgclass: "anyicon",
          description:
            "Vote on questions about TV, movies, music, celebrities and more",
        },
        2: {
          name: "Elections",
          color: "graycolor",
          image: require("@/assets/vote.png"),
          imgclass: "electionicon",
          description:
            "Vote and create elections from every<br/>corner of the World",
        },
      },
      data:[],
      
    };
  },
  mounted() {
    window.addEventListener("resize", this.handleResize);
    this.handleResize();
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.handleResize);
  },
  methods: {
     decryptMe(encryptStr){
      let encryptStrVal = CryptoJS.enc.Base64.parse(encryptStr);
      let encryptData = encryptStrVal.toString(CryptoJS.enc.Utf8);
          encryptData = JSON.parse(encryptData);
      let iv = CryptoJS.enc.Base64.parse(encryptData.iv);
      var decrypted = CryptoJS.AES.decrypt(encryptData.value,  CryptoJS.enc.Base64.parse(encryptionKey), {
            iv : iv,
            mode: CryptoJS.mode.CBC,
            padding: CryptoJS.pad.Pkcs7
        });
      decrypted = CryptoJS.enc.Utf8.stringify(decrypted); 
      
      return this.unserializePhpArray(decrypted);
    },
    unserializePhpArray(serializedString) 
    {
      try {
        const start = serializedString.indexOf(':"');
        const jsonString = serializedString.substring(start + 2, serializedString.length - 2);
        const result = JSON.parse(jsonString);
        
        return result;
      } catch (error) 
      {
        console.error("Error deserializing PHP array:", error);
        return {}; // Return an empty object in case of error
       }
    },
     onSlideChange() {
       this.showQuestion = true;
    },  
    onAfterSlideChange() {
       this.showQuestion = false;
    },
    handleResize() {
      const mobile = window.innerWidth <= 767;
      if (mobile !== this.isMobile) 
      {
        this.isMobile = mobile;
        this.$nextTick(() => {
          if (this.$refs.myCarousel && this.$refs.myCarousel.updateWidth) {
            this.$refs.myCarousel.updateWidth();
          }
        });
        const userTimezone = getUserTimezone();
         this.$store.dispatch("getLatestQstHomeAnother",{timezone: userTimezone}).then((response) =>{
          this.data = response.data;
        });
      }
    },
  },
};
</script>

<style>
@import "../assets/variables.css";
section {
  padding: 60px 0;
  overflow: hidden;
}
:root {
  --main-color: #fff;
}
.serviceBox {
  color: #fff;
  background: var(--main-color);
  font-family: "Poppins", sans-serif;
  text-align: right;
  padding: 25px 0;
  border-radius: 15px;
  box-shadow: 4px 4px 2px rgba(0, 0, 0, 0.1);
}
.serviceBox .title {
  background: rgba(0, 0, 0, 0.2);
  font-size: 18px;
  font-weight: 500;
  text-transform: uppercase;
  text-align: left;
  width: 90%;
  padding: 10px 10px 10px 30px;
  margin: 0 0 15px;
  display: inline-block;
  clip-path: polygon(10% 0, 100% 0%, 100% 100%, 0% 100%);
}
.serviceBox .description {
  font-size: 13px;
  font-weight: 300;
  letter-spacing: 0.5px;
  text-align: center;
  line-height: 24px;
  margin: 0 20px 15px;
}
.serviceBox .service-icon {
  background: rgba(0, 0, 0, 0.25);
  font-size: 40px;
  text-align: center;
  line-height: 85px;
  width: 85px;
  height: 85px;
  margin: 0 auto;
  border-radius: 50%;
}
.serviceBox.orangecolor {
  --main-color: #fe7900;
}
.serviceBox.bluecolor {
  --main-color: #002f8b;
}
.serviceBox.graycolor {
  --main-color: #666666;
}
.col-md-3 {
  -webkit-box-flex: 0;
  -ms-flex: 0 0 25%;
  flex: 0 0 30%;
  max-width: 30%;
}
@media only screen and (max-width: 1199px) {
  .serviceBox {
    margin: 0 0 30px;
  }
}
@media only screen and (max-width: 767px) {
  .serviceBox .title {
    padding-left: 60px;
  }
}
@media only screen and (max-width: 479px) {
  .serviceBox .title {
    padding-left: 35px;
  }
  .serviceBox {
    margin: 0 0 10px;
  }
}
.mainrow {
  justify-content: space-evenly;
  margin-top: 15px;
}
.sportsicon {
  width: 80%;
  margin-top: 14px;
}
img.electionicon {
  width: 66%;
  margin-left: 5px;
  margin-top: 8px;
}
.anyicon {
  width: 75%;
  margin-top: 11px;
}
.cursor {
  cursor: pointer;
}
.cursor a,
.cursor p {
  text-decoration: none;
}
.VueCarousel {
  width: 100% !important;
  max-width: 414px; /* stable width on mobile */
  margin: auto;
}
.VueCarousel-dot {
  margin-top: 0 !important;
}
.VueCarousel-dot-container {
  margin-top: 0 !important;
}
.VueCarousel-slide {
  min-height: 200px; /* lock height to prevent jumps */
}
</style>
